import { graphql } from '@teachino/shared-infrastructure';

export const reorderCourseTopicMutation = graphql(`
  mutation ReorderTopicInstance($reorderTopicInstanceInput: ReorderInput!) {
    reorderTopicInstance(
      reorderTopicInstanceInput: $reorderTopicInstanceInput
    ) {
      topicInstance {
        id
      }
    }
  }
`);
